// add class add-to-cart for ajax update cart
if (document.querySelector('.add-to-cart')) {
    let elements = document.getElementsByClassName('add-to-cart')

    for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', addToCart, false)
    }

}

function addToCart(e) {
    e.preventDefault()

    axios.post(e.target.getAttribute('href')).then(res => {
        updateCartWidget()
    })
}

function updateCartWidget() {
    axios.get('/cart/widget').then(res => {
        document.querySelector('.cart-count').textContent = res.data['count']
        document.querySelector('.cart__quantity_digit').textContent = res.data['count']
        document.querySelector('.cart-total-price').textContent = res.data['currency_total_price']
    })
}

import cart from './components/cart'

if (document.getElementById('shopping-cart')) {
    new Vue({
        el: '#shopping-cart',
        components: {
            cart
        }
    })
}

if (document.getElementById('show-cart-menu')) {
    let el = document.getElementById('cart-menu')
    let headerSearch = document.getElementById('header-search')

    if (el) {
        document.getElementById('show-cart-menu').addEventListener('click', function () {
            if (el.classList.contains('visible')) {
                el.classList.remove('visible')
                document.body.classList.remove('dark-bg')
            } else {
                el.classList.add('visible')
                document.body.classList.add('dark-bg')
                headerSearch.classList.remove('open')
            }
        }, false)
    }

    document.addEventListener('click', function (e) {
        const cartElement = document.getElementById('show-cart-menu')
        let targetElement = e.target

        do {
            if (cartElement === targetElement) {
                return
            }
            targetElement = targetElement.parentNode
        } while (targetElement)

        el.classList.remove('visible')
        document.body.classList.remove('dark-bg')
    })
}
